// extracted by mini-css-extract-plugin
export default {"orderTable":"styles_orderTable__7gZhK","button-customer-password-reset":"styles_button-customer-password-reset__g-GKO"};